import { BasketDeliveryAddress } from './BasketDeliveryAddress';
import { ContextualPricing } from './ContextualPricing';
import { CustomField } from './CustomField';
import { Discount } from './Discount';
import { Donation } from './Donation';
import { Fee } from './Fee';
import { Tax } from './Tax';

export class OrderReceived {
    id: string;
    oloid: number;
    vendorid: number;
    status: string;
    subtotal: number;
    salestax: number;
    taxes: Array<Tax>;
    fees: Array<Fee>;
    totalfees: number;
    donations: Array<Donation>;
    totaldonations: number;
    total: number;
    timemode: string;
    tip: number;
    mode: string;
    billingaccountid: number;
    billingaccountids: Array<string>;
    contextualpricing: ContextualPricing;
    deliveryaddress: BasketDeliveryAddress;
    customfields: Array<CustomField>;
    iseditable: boolean;
    discount: number;
    discounts: Array<Discount>;
    orderref: string;
    timeplaced: string;
    readytime: string;
    vendorname: string;
    vendorextref: string;
    deliverymode: string;
    customerhandoffcharge: number;
    arrivalstatus: string;
    hasolopass: boolean;
    products: Array<OrderStatusProduct>;
    posreferenceresponse: string;
    authtoken: string;

    public static Make(obj: any): OrderReceived {
        const orderReceived = new OrderReceived();
        Object.assign(orderReceived, obj);
        return orderReceived;
    }
}

export class OrderStatusProduct {
    id: string;
    chainproductid: string;
    name: string;
    quantity: number;
    totalcost: number;
    specialinstructions: string;
    custompassthroughdata: string;
    choices: Array<Choices>;
}

export class Choices {
    id: string;
    chainchoiceid: string;
    name: string;
    quantity: number;
}
